import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, CheckCircle2, Gift } from 'lucide-react';
export function ProductDetails() {
  const [expandedTomo, setExpandedTomo] = useState<number>(1);
  const tags = ['Planificación', 'Táctica', 'Preparación Física', 'Liderazgo', 'Baby Básquet', 'Mini Básquet', 'Infantil', 'Cadete', 'Juvenil', 'Fichas', 'Planillas', 'Padres', 'Evaluación', 'Scouting', 'Prevención', 'Mentalidad', 'Ejercicios'];
  const tomos = [{
    id: 1,
    title: 'La Temporada Perfecta',
    subtitle: 'Planificación anual sin improvisar',
    desc: 'Cómo planificar el año entero desde el primer entrenamiento hasta el último partido, para cada categoría de 5 a 17 años.',
    bullets: ['Las 3 fases de toda temporada ganadora', 'Planilla de 40 semanas lista para completar', 'Objetivos que funcionan según la edad', 'Protocolo de ajuste cuando el plan se rompe']
  }, {
    id: 2,
    title: 'El Entrenamiento Ideal',
    subtitle: 'Diseñá cada práctica con propósito',
    desc: 'Estructura paso a paso para armar entrenamientos dinámicos, intensos y que realmente enseñen a jugar.',
    bullets: ['Estructura de 120 minutos optimizada', 'Ejercicios de transición sin perder tiempo', 'Control de cargas en la semana', 'Método de corrección de errores en vivo']
  }, {
    id: 3,
    title: 'Conocé a tus Jugadores',
    subtitle: 'Evaluación y seguimiento individual',
    desc: 'Herramientas para medir el progreso real de cada pibe y tener datos concretos para mostrar.',
    bullets: ['Test físicos básicos por categoría', 'Planillas de tiro y fundamentos', 'Guía para entrevistas 1 a 1', 'Fichas médicas y de contacto']
  }, {
    id: 4,
    title: 'Básquet por Edades',
    subtitle: 'Qué enseñar en cada etapa',
    desc: 'El currículum completo de contenidos técnicos y tácticos adaptados al desarrollo cognitivo y físico.',
    bullets: ['Fundamentos lúdicos para Mini', 'Introducción táctica en Infantiles', 'Sistemas y lectura para Cadetes', 'Perfeccionamiento y scouting Juvenil']
  }, {
    id: 5,
    title: 'El Profe que Lidera',
    subtitle: 'Grupo, vestuario y familias',
    desc: 'Cómo manejar la psicología del equipo, resolver conflictos y alinear a los padres con tu visión.',
    bullets: ['Manejo de egos y minutos de juego', 'Estructura para reuniones de padres', 'Charlas pre y post partido efectivas', 'Resolución de conflictos en el vestuario']
  }, {
    id: 6,
    title: 'Cuerpos que Crecen',
    subtitle: 'Preparación física sin riesgos',
    desc: 'Rutinas seguras y efectivas para desarrollar atletas sin comprometer su crecimiento ni causar lesiones.',
    bullets: ['Prevención de lesiones comunes', 'Fuerza con peso corporal progresiva', 'Pliometría adaptada por edades', 'Protocolos de recuperación']
  }];
  const bonos = [{
    id: 'B1',
    title: 'La Biblia del Calentamiento',
    desc: '30 rutinas de entrada en calor diferenciadas por categoría listas para usar mañana mismo'
  }, {
    id: 'B2',
    title: 'El Cuaderno del DT',
    desc: 'Todas las planillas que un entrenador necesita: asistencia, partido, ficha de jugador y más. Imprimí y usá'
  }, {
    id: 'B3',
    title: 'Mente Ganadora',
    desc: 'Cómo trabajar la cabeza de tus jugadores para que rindan bajo presión y se recuperen del error'
  }, {
    id: 'B4',
    title: 'El Libro de los Ejercicios',
    desc: '40 ejercicios técnicos con diagrama, descripción y progresión por nivel organizados por fundamento'
  }, {
    id: 'B5',
    title: 'Hablá con los Padres',
    desc: 'Guías de conversación y protocolos para las situaciones más difíciles con las familias'
  }, {
    id: 'B6',
    title: 'El Partido bien Preparado',
    desc: 'Planilla de scouting, pizarra táctica imprimible y rutina prematch completa para cada categoría'
  }];
  return <section id="includes" className="bg-white py-12 md:py-20 border-t border-gray-200" data-id="element-239">
      <div className="max-w-6xl mx-auto px-4" data-id="element-240">
        {/* Header & Tags */}
        <div className="text-center mb-10 md:mb-16" data-id="element-241">
          <div className="inline-block bg-brand-dark text-white px-3 py-1 md:px-4 md:py-1.5 rounded-full text-[10px] md:text-xs font-bold tracking-widest uppercase mb-4 md:mb-6 leading-snug" data-id="element-242">
            Sistema Completo · 6 Tomos + 6 Bonos + 2 PRO · 5 a 17 años
          </div>
          <h2 className="font-display text-4xl md:text-7xl text-brand-dark mb-4 md:mb-8" data-id="element-243">
            660+ PÁG.
          </h2>

          <div className="flex flex-wrap justify-center gap-1.5 md:gap-2 max-w-4xl mx-auto" data-id="element-244">
            {tags.map((tag, i) => <motion.span key={i} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.02
          }} className="bg-gray-100 text-gray-700 px-2.5 py-1 md:px-3 md:py-1.5 rounded-md text-xs md:text-sm font-semibold border border-gray-200" data-id="element-245">
                {tag}
              </motion.span>)}
          </div>
        </div>

        {/* 6 Tomos */}
        <div className="mb-12 md:mb-24" data-id="element-246">
          <div className="text-center mb-6 md:mb-10" data-id="element-247">
            <h3 className="text-brand-orange font-bold tracking-widest uppercase text-xs md:text-sm mb-2" data-id="element-248">
              Contenido Completo
            </h3>
            <h2 className="font-display text-3xl md:text-4xl text-brand-dark" data-id="element-249">
              LOS 6 TOMOS PRINCIPALES
            </h2>
            <p className="text-gray-600 mt-2 text-sm md:text-base font-medium" data-id="element-250">
              Tu hoja de ruta completa para organizar, planificar y liderar tus
              categorías
            </p>
          </div>

          <div className="max-w-4xl mx-auto space-y-3 md:space-y-4" data-id="element-251">
            <p className="text-center text-xs md:text-sm font-bold text-gray-400 mb-3 md:mb-4" data-id="element-252">
              Tocá cada tomo para ver lo que incluye ☝️
            </p>

            {tomos.map(tomo => {
            const isOpen = expandedTomo === tomo.id;
            return <motion.div key={tomo.id} layout className={`border-2 rounded-xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-brand-orange shadow-lg' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-253">
                  <button onClick={() => setExpandedTomo(isOpen ? 0 : tomo.id)} className="w-full flex items-center justify-between p-4 md:p-6 bg-white text-left focus:outline-none active:bg-gray-50" data-id="element-254">
                    <div className="flex items-center gap-3 md:gap-6 min-w-0" data-id="element-255">
                      <div className={`w-10 h-10 md:w-16 md:h-16 flex items-center justify-center rounded-lg font-display text-lg md:text-3xl shrink-0 transition-colors ${isOpen ? 'bg-brand-orange text-white' : 'bg-gray-100 text-gray-400'}`} data-id="element-256">
                        T{tomo.id}
                      </div>
                      <div className="min-w-0" data-id="element-257">
                        <h4 className="font-display text-base md:text-2xl text-brand-dark leading-tight truncate" data-id="element-258">
                          {tomo.title}
                        </h4>
                        <p className="text-gray-500 font-medium text-xs md:text-base leading-tight" data-id="element-259">
                          {tomo.subtitle}
                        </p>
                      </div>
                    </div>
                    <motion.div animate={{
                  rotate: isOpen ? 180 : 0
                }} className="text-gray-400 shrink-0 ml-2" data-id="element-260">
                      <ChevronDown size={22} data-id="element-261" />
                    </motion.div>
                  </button>

                  <AnimatePresence initial={false} data-id="element-262">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25
                }} className="bg-orange-50/60 border-t border-orange-100 overflow-hidden" data-id="element-263">
                        <div className="p-4 md:p-8 md:pl-28" data-id="element-264">
                          <p className="text-gray-800 text-sm md:text-base font-medium mb-4 md:mb-6 leading-relaxed" data-id="element-265">
                            {tomo.desc}
                          </p>
                          <ul className="space-y-2 md:space-y-3" data-id="element-266">
                            {tomo.bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-2 md:gap-3" data-id="element-267">
                                <CheckCircle2 className="text-brand-orange shrink-0 mt-0.5" size={18} data-id="element-268" />
                                <span className="text-gray-700 text-sm md:text-base font-medium" data-id="element-269">
                                  {bullet}
                                </span>
                              </li>)}
                          </ul>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </motion.div>;
          })}
          </div>
        </div>

        {/* 6 Bonos — Row Layout */}
        <div className="bg-brand-dark rounded-2xl md:rounded-3xl p-5 md:p-12 relative overflow-hidden" data-id="element-270">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-orange opacity-10 rounded-full blur-3xl" data-id="element-271"></div>

          <div className="text-center mb-6 md:mb-12 relative z-10" data-id="element-272">
            <h3 className="text-brand-orange font-bold tracking-widest uppercase text-xs md:text-sm mb-2" data-id="element-273">
              Incluidos Gratis
            </h3>
            <h2 className="font-display text-2xl md:text-5xl text-white leading-tight" data-id="element-274">
              6 BONOS ESTRATÉGICOS
            </h2>
            <p className="text-gray-400 mt-1 md:mt-2 text-xs md:text-base font-medium" data-id="element-275">
              Sin costo extra — incluidos en ambas ofertas
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 md:gap-3 relative z-10 max-w-4xl mx-auto" data-id="element-276">
            {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.04
          }} whileHover={{
            x: 4
          }} className="bg-gray-900 border border-gray-800 hover:border-brand-orange rounded-xl p-3 md:p-4 transition-colors flex items-center gap-3 md:gap-4" data-id="element-277">
                <div className="font-display text-lg md:text-xl bg-brand-orange/15 text-brand-orange w-11 h-11 md:w-12 md:h-12 rounded-lg flex items-center justify-center shrink-0" data-id="element-278">
                  {bono.id}
                </div>
                <div className="flex-grow min-w-0" data-id="element-279">
                  <div className="flex items-center gap-2 mb-0.5 flex-wrap" data-id="element-280">
                    <h4 className="font-bold text-white text-sm md:text-base leading-tight" data-id="element-281">
                      {bono.title}
                    </h4>
                    <span className="bg-brand-orange/20 text-brand-orange text-[9px] md:text-[10px] font-bold px-1.5 py-0.5 rounded uppercase tracking-wider flex items-center gap-0.5 shrink-0" data-id="element-282">
                      <Gift size={9} data-id="element-283" /> Gratis
                    </span>
                  </div>
                  <p className="text-gray-400 text-xs md:text-sm leading-snug" data-id="element-284">
                    {bono.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>

          <div className="mt-6 md:mt-12 text-center relative z-10" data-id="element-285">
            <div className="inline-block border-2 border-brand-orange text-brand-orange font-display text-base md:text-2xl px-4 py-2.5 md:px-8 md:py-4 rounded-lg bg-brand-dark/50 backdrop-blur-sm leading-tight" data-id="element-286">
              VALOR TOTAL BONOS: $48.000 —{' '}
              <span className="text-white" data-id="element-287">GRATIS</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}